import React  from "react";
import { Link } from 'react-router-dom';

export default function Logo() {
    return <Link to="/" className="logo-placeholder">MorganPage</Link>
}